import { render } from "./UserVideos.vue?vue&type=template&id=792b8728"
import script from "./UserVideos.vue?vue&type=script&lang=js"
export * from "./UserVideos.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\zoodkomak_tv_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__